import { Avatar, Box, CircularProgress, Grid, Typography } from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../appConstants";
import showToast from "../../../components/Hot-Toast/showToast";
import { jobRoleOnBoardSchema } from "../../../hooks/validationSchema";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { fetchJobRoles, fetchJobRoleSpecialities } from "../../../utils/commonAPI";
import { useTMutation } from "../../../utils/useTMutation";
import { useTQuery } from "../../../utils/useTQuery";
import SPECIALITY from "../../../assets/images/big/speciality.png";


const JobSpecialty = () => {
    const navigate = useNavigate();
    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data => { return data }))
    const dispatch = useDispatch()
    const { jobData, step } = useSelector(state => state.job)
    const { data: specialties = [], isLoading, isError, error } = useQuery({
        queryKey: ['specialties'],
        queryFn: () => fetchJobRoleSpecialities(jobData.JOBROLE_ID  ,"Clinician"),
        staleTime: 1000 * 60 * 2,
    });

    console.log("spss",specialties)
   
    console.log("adsadadsa" , error)
 
    const onSubmitNext = async (data) => {
        try {
            const response = await mutateAsync({SPECIALTY_ID:data.ID, ID: jobData.ID, STEP: jobData.REDIRECT ? 8 : step + 1 });
            if (response.STATUS) {
                if (jobData.REDIRECT) {
                    dispatch(customStep(8))
                } else {
                    dispatch(nextStep())
                }
                dispatch(update({ SPECIALTY_NAME :data?.SPECIALTY_NAME,SPECIALTY_ID:data.ID , "REDIRECT": false }))

            } else {
                showToast("error", data.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Validation Request failed:", error.message);
            showToast("error", error.message || "Something went wrong, Please try again", 3000);
        }
    }
    return (
        <>
            <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={3} pb={3}>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h3" className="about-texts">
                        {/* Speciality */}
                        What are your job speciality?
                    </Typography>
                </Grid>
                {isLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                        <CircularProgress />
                    </Box>
                ) : (

                            <Grid container spacing={3} mt={1} >
                                {specialties.map((spec) => (
                                    <Grid item lg={4}>
                                        {/* <Avatar
                                            src={spec?.IMAGE_NAME ? API_URL + "user/viewFile?fileName=" + spec?.IMAGE_NAME : null }
                                            className="avtar"
                                            onClick={()=>onSubmitNext(spec)}
                                            sx={{
                                                borderRadius: 5,
                                                width: 120,
                                                height: 80,
                                                border: jobData?.SPECIALTY_ID === spec.ID ? '2px solid #ff0000' : '3px solid #76c8eb'  , // Change border on selection
                                                transition: 'border-color 0.3s ease', 
                                                cursor: 'pointer', 
                                              }}
                                        /> */}


<Box display="flex" justifyContent="center">

<img src={SPECIALITY}  alt="image" 
   onClick={()=>onSubmitNext(spec)}
 style={{ 

    borderRadius: 20,
    width: 120,
    height: 80,
    border: jobData?.SPECIALTY_ID === spec.ID ? '2px solid #ff0000' : '3px solid #76c8eb'  , // Change border on selection
    transition: 'border-color 0.3s ease', 
    cursor: 'pointer',
    objectFit:"cover"
 }}
 />
</Box>
                                        <Typography style={{paddingTop:"2px" ,textAlign:"center"}}>{spec?.SPECIALTY_NAME}</Typography>

                                    </Grid>

                                ))}


                            </Grid>
                   
                )}
                {isError && (
                    <Typography color="error">Failed to load job roles. Please try again later.</Typography>
                )}

            </Grid>

        </>


    )
};

export default JobSpecialty;


